module.exports = __webpack_public_path__ + "img/jap.20b94d92.svg";